export default __webpack_public_path__ + "static/media/SharePizza_15.942edf78.png";